var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":_vm.name,"label":_vm.label,"label-for":_vm.name}},[_c('datepicker',{attrs:{"value":_vm.dateValue,"id":_vm.name,"name":_vm.name},on:{"selected":_vm.updateField}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }